import axios from 'axios';
import store from '../../store';

const model = () => {
	return {
		id: 			null,
		name:			'',
		vat:			'',
		ean:			'',
		att: 			'',
		address:		'',
		zip:			'',
		city:			'',
		phone:			'',
		email:			'',

		_embedded: {
			managers: 	[],
			prices: 	[]
		}
	};
};

const search = async (params) => {
	return (await axios.get('/customers/search', { params })).data;
};

const save = async (model) => {
	try {
		return (model.id ? await axios.put(`/customers/${model.id}`, model) : await axios.post(`/customers`, model)).data;
	} catch (err) {
		return false;
	}
};

const read = async(id) => {
	return (await axios.get(`/customers/${id}`)).data;
};

const dialog = async (model, submit) => {
	store.dispatch('win/push', {
		component: 	'customer-window-view',
		model:		model,
		async submit(model) {
			return await submit(model);
		}
	});
};

const open = async (model, onSave) => {
	dialog(model, async (model) => {
		const r = await save(model);

		if (r) {
			if (onSave) onSave(r);
			return true;
		}

		return false;
	});
};

const del = async (id) => {
	await axios.delete(`/customer/${id}`);
};

export default {
	model,
	search,
	save,
	read,
	open,
	dialog,
	del
};